module.exports = __webpack_public_path__ + "b922edb3f9da6741d825cee2d6a0b07b.pdf";